import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import api from '../api';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email, password });
      const data = res && res.data ? res.data : null;
      if (data && data.success && data.token) {
        localStorage.setItem('token', data.token);
        // store role returned by server (falls back to 'admin')
        localStorage.setItem('role', data.role || 'admin');
        localStorage.setItem('name', data.name || 'Admin');
        navigate('/admin/upload');
      } else {
        alert((data && data.message) || 'Login failed');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) alert(err.response.data.message);
      else alert('Error: ' + (err.message || 'Request failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card container">
        <h2>Reporter Login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="admin-email">Email</label>
            <input id="admin-email" className="fancy-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="admin-pass">Password</label>
            <input id="admin-pass" className="fancy-input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
          </div>
          <button type="submit">Login</button>
        </form>
        <div className="auth-footer">Don't have an account? <a href="/admin/register">Register</a></div>
      </div>
      
      {loading && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div className="loading">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminLogin;
